/** FGTS × QI Tech — endpoints da v2 da API. */
import { httpV2 as http } from '@/services/api';

export async function list(params) {
  return http.get('/fgts/balance-wait-list', { params });
}

export async function addClientNicknameToSimulation(balanceId, params) {
  return http.put(`/fgts/balance-wait-list/${balanceId}`, params);
}

export async function selectSimulation(data) {
  return http.post('/fgts/select-simulation', data);
}

export async function balanceWaitListFilters() {
  return http.get('/fgts/balance-wait-list/filters');
}
